import React, { useState } from 'react';
import { BookOpen, Save } from 'lucide-react';
import { useAppDataContext } from '../../context/AppDataContext';
import { userKey } from '../../lib/deviceStore';

interface JournalGameProps {
  onComplete: (score: number) => void;
}

export default function JournalGame({ onComplete }: JournalGameProps) {
  const [text, setText] = useState('');
  const [title, setTitle] = useState('');
  const { profile } = useAppDataContext();

  const handleSave = () => {
    if (text.length > 2 && profile) {
      // Save locally for the Profile Diary feature
      const key = userKey('remind_diary', profile.id);
      const saved = localStorage.getItem(key);
      const entries = saved ? JSON.parse(saved) : [];

      const defaultTitle = `מכתב מספר ${entries.length + 1} - ${new Date().toLocaleDateString('he-IL')}`;
      const finalTitle = title.trim() || defaultTitle;

      entries.push({
        id: Date.now(),
        date: new Date().toISOString(),
        title: finalTitle,
        text: text
      });
      localStorage.setItem(key, JSON.stringify(entries));

      onComplete(20);
    }
  };

  return (
    <div className="flex flex-col h-[70vh] p-4 text-foreground">
      <div className="flex items-center gap-2 mb-4">
        <BookOpen className="text-yellow-400" />
        <h2 className="text-xl font-bold">היומן שלי</h2>
      </div>
      <p className="text-muted-foreground text-sm mb-4">כתוב מחשבה אחת טובה שעברה עליך היום...</p>

      <input
        type="text"
        className="bg-muted/50 border border-border rounded-xl p-3 mb-2 text-foreground focus:outline-none focus:border-yellow-500 dir-rtl"
        placeholder="כותרת (אופציונלי)..."
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      <textarea
        className="flex-1 bg-muted/50 border border-border rounded-xl p-4 text-foreground focus:outline-none focus:border-yellow-500 resize-none dir-rtl"
        placeholder="היום הרגשתי..."
        value={text}
        onChange={(e) => setText(e.target.value)}
      />

      <button
        onClick={handleSave}
        disabled={text.length <= 10}
        className={`mt-4 p-4 rounded-xl font-bold flex items-center justify-center gap-2 transition-all ${text.length > 10 ? 'bg-yellow-500 text-black hover:bg-yellow-400' : 'bg-muted text-muted-foreground'
          }`}
      >
        <Save size={20} /> שמור ביומן
      </button>
    </div>
  );
}
